import { render, staticRenderFns } from "./LegalDocumentTaskStatus.vue?vue&type=template&id=3a39844e&"
import script from "./LegalDocumentTaskStatus.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports